"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Player = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _Slider = _interopRequireDefault(require("./Slider.js"));
var _settings = require("./settings.js");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _defaultTemplate = _interopRequireDefault(require("./defaultTemplate.js"));
var _defaultProps = _interopRequireDefault(require("recompose/defaultProps"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Player = exports.Player = /*#__PURE__*/function (_React$Component) {
  _inherits(Player, _React$Component);
  function Player() {
    _classCallCheck(this, Player);
    return _callSuper(this, Player, arguments);
  }
  _createClass(Player, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        field = _this$props.field,
        settings = _this$props.settings,
        isMatrixMode = _this$props.isMatrixMode,
        showRequiredState = _this$props.showRequiredState,
        registerAction = _this$props.registerAction,
        setParameters = _this$props.setParameters,
        accommodations = _this$props.accommodations,
        showQuestionNumbers = _this$props.showQuestionNumbers,
        startQuestionNumber = _this$props.startQuestionNumber;
      var elementStyle = (0, _get2["default"])(this.props, 'playerTemplateProps.playerTemplateSettings.elementStyle');
      var templateProps = _objectSpread({
        question: !isMatrixMode && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: settings.question,
          showRequiredState: showRequiredState && settings.isAnswerRequired,
          registerAction: this.props.registerAction.bind(null, 1),
          setParameters: this.props.setParameters,
          accommodations: accommodations,
          prependWith: showQuestionNumbers && "".concat(startQuestionNumber, ". ")
        }), settings.description && /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].description
        }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: settings.description
        }))),
        slider: /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
          registerAction: registerAction,
          setParameters: setParameters,
          settings: settings,
          field: field,
          accommodations: accommodations
        }),
        sliderComponent: (0, _defaultProps["default"])({
          settings: settings,
          field: field,
          registerAction: registerAction,
          setParameters: setParameters,
          accommodations: accommodations
        })(_Slider["default"]),
        // Advanced props
        settings: settings,
        field: field,
        playerTemplateProps: this.props.playerTemplateProps,
        accommodations: accommodations,
        elementStyle: isMatrixMode ? '' : elementStyle
      }, this.props.templateExtraProps);
      var Template = this.props.template || _defaultTemplate["default"];
      return /*#__PURE__*/_react["default"].createElement(Template, templateProps);
    }
  }]);
  return Player;
}(_react["default"].Component);
_defineProperty(Player, "propTypes", {
  settings: _propTypes["default"].object,
  field: _propTypes["default"].object,
  isMatrixMode: _propTypes["default"].bool,
  showRequiredState: _propTypes["default"].bool,
  showQuestionNumbers: _propTypes["default"].bool,
  startQuestionNumber: _propTypes["default"].number,
  template: _propTypes["default"].func,
  templateExtraProps: _propTypes["default"].object,
  playerTemplateProps: _propTypes["default"].object,
  registerAction: _propTypes["default"].func,
  setParameters: _propTypes["default"].func,
  accommodations: _propTypes["default"].object
});
_defineProperty(Player, "defaultProps", {
  isMatrixMode: false,
  registerAction: function registerAction() {},
  setParameters: function setParameters() {}
});
var _default = exports["default"] = (0, _cccisdSurveyCommon.playerWrapper)({
  validate: _settings.validate
})(Player);